<template>
  <div>
    <el-form :inline="true" :model="searchParam" size="mini">
      <el-form-item>
        <div>
          <span class="color-333 font-weight font-16">详细接单情况</span>
          <span class="color-666 font-12 margin-left-10"
            >共接单 {{ orderData.orderTotal }}单，已完成{{ orderData.orderFinish }}单</span
          >
        </div>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input
          v-model="searchParam.orderNo"
          clearable
          placeholder="请输入"
          oninput="value=value.replace(/[^\d]/g, '')"
        />
      </el-form-item>
      <el-form-item label="预计出行时间">
        <el-date-picker
          v-model="searchParam.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          value="yyyy-MM-dd"
          :clearable="false"
        />
      </el-form-item>
      <el-form-item>
        <el-button size="mini" @click="handleSearch" :loading="loading">查询</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script >
import { inject } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const searchParam = inject('searchParam');
  const orderData = inject('orderData');
  const loading = inject('loading');
  const search = inject('search');
  const handleSearch = () => {
    const {
      date
    } = searchParam.value;
    if (date) {
      const [startDate, endDate] = date;
      searchParam.value.startDate = startDate;
      searchParam.value.endDate = endDate;
    } else {
      searchParam.value.startDate = searchParam.value.endDate = '';
    }
    search();
  };
  return {
    searchParam,
    orderData,
    loading,
    handleSearch
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  ::v-deep .el-button--mini {
    background: #22c655;
    color: #fff;
  }
</style>
